<template>
  <footer>
    <p>{{copyright}}</p>
  </footer>
</template>

<script>
export default {
  data(){
    return{
      copyright: '© kkimu',
    };
  },
};
</script>

<style>
footer {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/globals/Footer.vue